// {{ $t('分享') }}
// this.$t('云官网')
// $t('云官网')
export default {
  请选择所属行业: 'Please select the industry you belong to',
  所属行业不能为空: 'Industry cannot be empty',
  拖动照片可以调整顺序: 'Drag the photos to adjust the order',
  该企业主页不存在: "This company page doesn't exist.",
  已停止访问该网页: 'Site Blocked',
  原因如下: 'Reasons are as follows',
  上市公司: 'Listed Company',
  世界500强: 'Fortune Global 500 Company',
  营业执照: 'Business License',
  云工商: 'Company Details',
  公司官网: 'Company Official Website',
  交换云展: 'Exchange Card',
  立即分享: 'Share Immediately',
  在线洽谈: 'Chat Now',
  云上企业: 'Virtual Company Tour',
  云展厅: 'Virtual Company Tour',
  企业视频: 'Videos',
  云视频: 'Videos',
  企业简介: 'Introduction',
  查看全文: 'Read More',
  收起全文: 'Read Less',
  合作伙伴: 'Business Partners',
  企业相册: 'Photos',
  企业员工: 'Employees',
  企业荣誉: 'Achievements',
  投资机构: 'Investors',
  对外投资: 'Investees',
  联系我们: 'Contact Info',
  提醒更新: 'Send an Update Reminder',
  暂未上传云企业: 'No contents yet.',
  暂未上传云产品: 'No exhibits available yet.',
  暂无云直播: 'No live streams yet.',
  暂无参展: 'Haven’t participated in any exhibitions yet.',
  暂无开展: 'No exhibitions yet.',
  暂无云招标信息: 'No tender information yet.',
  暂无云动态: 'No company news yet.',
  暂无云头条: 'No industry news yet.',
  暂无上传云模型: 'No designs uploaded yet.',
  暂无云海报: 'No poster templates yet.',
  暂无云会议: 'No conferences yet.',
  暂无云招聘: 'Currently no vacancies available.',
  暂未上传云伙伴: 'No contents available yet.',
  暂未上传云相册: 'No photos available yet.',
  暂未上传云同事信息: 'No contents available yet.',
  暂未上传云荣誉: 'No contents available yet.',
  暂无员工名片: 'No employee business card',
  暂未上传企业视频: 'No videos available yet.',
  注册资本: 'Registered Capital',
  成立日期: 'Date of Establishment ',
  所属行业: 'Industry',
  企业地址: 'Company Address',
  发布的展览: 'My Exhibitions',
  发布的会议: 'My Conferences',
  直播: 'Live Streams',
  招标: 'Tenders',
  产业头条: 'Industry Headlines',
  动态: 'News',
  展品: 'Exhibits',
  参展的展览: 'Participated Exhibitions',
  展厅模型: 'Exhibition Space Designs',
  海报制作: 'Poster Templates',
  确认删除吗: 'Are you sure you want to delete this item?',
  删除: 'Delete',
  人浏览过: 'Total Views',
  浏览者头像: 'Profile Photo',
  确认: 'Yes',
  取消: 'Cancel',
  删除提示: 'Delete Tip',
  发布: 'Published',
  投资比例: 'Investment Proportion',
  认缴金额: 'Subscribed Capital',
  万元: 'Million',
  云上: 'Cloud',
  交换: 'Exchange',
  企业云展系统: 'Enterprises',
  完善企业云展系统: 'Complete the company cloud exhibition system',
  获客营销神器: 'Customer Marketing Tools',
  足不出户带客户同逛企业: 'Footsteps to Customers',
  与全球客户实时洽谈互动: 'Interactive with Global Customers',
  智能推送精准客户: 'Intelligent Push of Precise Customers',
  实时掌握访问数据: 'Real-time Data of Visits',
  去完善: 'Complete',
  编辑: 'Edit',
  分享: 'Share',
  企业: 'Company',
  电话: 'Phone',
  邮箱: 'E-mail',
  地址: 'Address',
  请更新名片: 'Please update the business card.',
  立即更新: 'Update Now',
  修改名片: 'Edit Business Card',
  复制链接成功: 'URL copy successfully.',
  复制失败提示: 'URL copy unsuccessfully. Please try again on another browser or copy manually：',
  分享失败提示: 'Share unsuccessful. Please try again later.',
  微信小程序码生成错误: 'WeChat Applet QR Code Generation Error',
  企业信息: 'Enterprise Info',
  暂无企业地址: 'No company address yet.',
  暂无联系人信息: 'No contact info yet.',
  二维码: 'QR Code',
  微信公众号: 'WeChat Official Account',
  微信小程序: 'WeChat Applet',
  微信小程序二维码: 'WeChat Applet',
  暂无二维码信息: 'No QR code yet.',
  微博: 'Sina Weibo',

  '+ 关注': '+  Follow',
  个人动态: 'Personal news',

  云官网: 'Company Official Website',
  我的名片: 'My Cloud Exhibition System',
  编辑云展信息: 'Edit account info',
  云企业: 'Cloud Enterprise',
  云简介: 'Introduction',
  云伙伴: 'Business Partners',
  云相册: 'Photos',
  云同事: 'Employees',
  云荣誉: 'Achievements',
  云投资: 'Investors',
  云战略: 'Investees',
  云直播: 'Live Streams',
  云招标: 'Tenders',
  云头条: 'Headlines',
  云动态: 'News',
  云产品: 'Cloud Products',
  云展览: 'CloudExhibitions',
  云模型: 'Exhibition Space Designs',
  云海报: 'Poster',
  提升权益: 'Upgrade Membership',
  外呼呼叫: 'AI Outbound Call',
  去外呼: 'Go Outbound Call',
  充值点数: 'Recharge Points',
  冻结中点数: 'Frozen Points',
  到期时间: 'Expiration Date',
  话术管理: 'Script Management',
  外呼任务管理: 'Outbound Call Task Management',
  呼叫记录: 'Call Records',
  企业客户库: 'Corporate Customer Database',
}
